import { Home, Search, MessageCircle, UtensilsCrossed, User } from "lucide-react";
import { NavLink } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { motion } from "framer-motion";

const navItems = [
  { path: "/patient-home", icon: Home, labelKey: "nav.home" },
  { path: "/find-dietitian", icon: Search, labelKey: "nav.find" },
  { path: "/patient-inbox", icon: MessageCircle, labelKey: "nav.inbox" },
  { path: "/patient-meals", icon: UtensilsCrossed, labelKey: "nav.meals" },
  { path: "/patient-profile", icon: User, labelKey: "nav.profile" },
];

const BottomNav = () => {
  const { t } = useLanguage();

  return (
    <nav className="fixed bottom-3 left-1/2 z-50 w-[calc(100%-1.5rem)] max-w-sm -translate-x-1/2 rounded-full border border-[#e2ebe4] bg-white px-2 py-2 pb-safe">
      <div className="flex items-center justify-around gap-1">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end
            className="flex flex-col items-center gap-0.5 min-w-0 flex-1"
          >
            {({ isActive }) => (
              <motion.div
                className="flex min-w-14 flex-col items-center gap-0.5"
                animate={isActive ? { y: -2 } : { y: 0 }}
                transition={{ type: "spring", stiffness: 400, damping: 20 }}
              >
                <div
                  className={`p-2 rounded-xl transition-all duration-200 ${
                    isActive ? "bg-[#d8f2ed]" : "bg-transparent"
                  }`}
                >
                  <item.icon
                    className={`h-5 w-5 transition-colors ${
                       isActive ? "text-primary" : "text-muted-foreground"
                    }`}
                  />
                </div>
                <span
                  className={`text-[10px] font-semibold transition-colors ${
                    isActive ? "text-primary" : "text-muted-foreground"
                  }`}
                >
                  {t(item.labelKey)}
                </span>
              </motion.div>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
